import config from '../../config';

const { constants: { dataGrid: { operators } } } = config;

export default operators;
